module.exports = __webpack_public_path__ + "img/communityadminpainpoint4.0e82d8af.png";